import classNames from "classnames";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	svg: {
		fill: theme.palette.colors.purplishBlue,
		stroke: theme.palette.colors.purplishBlue,
		width: ({ size }) => size,
		display: "block",
	},
}));

const ESimIcon = ({ size = 34, className }) => {
	const classes = useStyles({ size });

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="96.35 119.98 307.65 184.02"
			className={classNames(classes.svg, className)}
		>
			<g>
				<polygon
					points="100.348 171.747 100.348 300 400 300 400 123.977 142.43 123.977"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeDasharray="0, 16"
					strokeWidth="8px"
					strokeDashoffset="10px"
					id="svg_1"
				></polygon>
				<path
					d="m178.503,246.055q5.48,0.042 10.684,-1.997q5.204,-2.039 8.262,-6.287l-5.225,-6.415q-2.464,2.549 -5.671,3.93q-3.207,1.38 -6.818,1.253q-2.294,-0.042 -4.078,-0.871q-1.784,-0.828 -2.974,-2.23q-1.232,-1.402 -1.869,-3.292q-0.637,-1.891 -0.552,-4.1l30.034,0l0.764,-5.012q0.553,-4.461 -0.233,-8.496q-0.786,-4.036 -2.91,-7.18q-2.167,-3.101 -5.65,-4.97q-3.484,-1.869 -8.284,-1.996q-3.441,-0.085 -6.542,0.785q-3.101,0.871 -5.735,2.443q-2.081,1.274 -3.908,2.995q-1.827,1.72 -3.356,3.674q-2.166,2.974 -3.547,6.542q-1.381,3.569 -1.805,7.392l-0.17,1.742q-0.425,4.673 0.807,8.666q1.232,3.993 3.865,6.924q2.592,2.974 6.394,4.715q3.802,1.742 8.517,1.785zm4.631,-38.148q1.911,0.085 3.377,0.786q1.465,0.701 2.442,1.89q0.935,1.19 1.317,2.804q0.383,1.614 0.085,3.484l-0.212,1.062l-18.734,0q0.807,-1.87 1.869,-3.696q1.062,-1.827 2.506,-3.271q1.402,-1.445 3.229,-2.294q1.827,-0.85 4.121,-0.765z"
					id="svg_2"
				></path>
				<path
					d="m242.505,229.062q0,1.657 -0.68,3.038q-0.679,1.38 -1.954,2.357q-1.274,0.977 -3.122,1.53q-1.848,0.552 -4.227,0.552q-2.676,0 -4.906,-0.595q-2.23,-0.594 -3.802,-1.869q-1.614,-1.274 -2.507,-3.271q-0.892,-1.996 -0.977,-4.8l-11.724,0q0,4.8 1.848,8.368q1.848,3.569 5.034,6.203q3.356,2.676 7.88,4.057q4.524,1.38 9.154,1.38q4.716,0 8.709,-1.126q3.993,-1.125 6.882,-3.334q2.888,-2.167 4.524,-5.332q1.635,-3.164 1.635,-7.243q0,-4.715 -2.166,-8.326q-2.167,-3.611 -5.82,-6.329q-2.421,-1.657 -5.31,-2.931q-2.889,-1.275 -6.075,-2.167q-2.973,-0.807 -5.331,-1.742q-2.358,-0.934 -4.015,-2.081q-1.656,-1.105 -2.527,-2.507q-0.871,-1.401 -0.871,-3.143q0,-1.657 0.658,-3.08q0.659,-1.423 1.933,-2.485q1.275,-1.02 3.123,-1.593q1.848,-0.574 4.226,-0.574q2.592,0 4.525,0.701q1.932,0.701 3.249,1.933q1.275,1.275 1.933,3.016q0.659,1.742 0.744,3.824l11.639,0q0,-4.163 -1.614,-7.647q-1.614,-3.483 -4.503,-6.032q-2.889,-2.506 -6.903,-3.908q-4.014,-1.402 -8.857,-1.402q-4.673,0 -8.666,1.211q-3.993,1.21 -6.924,3.462q-2.932,2.251 -4.588,5.437q-1.657,3.186 -1.657,7.094q0,3.399 1.253,6.288q1.253,2.888 3.717,5.267q2.464,2.379 6.351,4.376q3.887,1.996 9.027,3.398q3.314,0.892 5.544,1.933q2.23,1.041 3.632,2.273q1.359,1.274 1.933,2.718q0.573,1.445 0.573,3.101z"
					id="svg_3"
				></path>
				<path
					d="m265.227,183.353l0,9.644l11.767,0l0,42.607l-11.767,0l0,9.601l35.768,0l0,-9.601l-12.064,0l0,-42.607l12.064,0l0,-9.644l-35.768,0z"
					id="svg_4"
				></path>
				<path
					d="m329.452,183.353l-14.826,0l0,61.852l10.96,0l0,-18.309l-0.51,-27.782l7.265,25.7l5.904,0l8.114,-26.847l-0.51,28.929l0,18.309l10.96,0l0,-61.852l-14.825,0l-6.67,23.237l-5.862,-23.237z"
					id="svg_5"
				></path>
			</g>
		</svg>
	);
};

export default ESimIcon;
